<template>
	<div>
		<ol>
			<li v-for="(field, index) in fields"
				v-bind:key="index">
				   <span>{{ field.name ? field.name : "Pole bez nazwy" }}</span>
				<v-icon @click="moveFieldUp(index)" flat v-if="fieldCanBeMovedUp(index)">
					arrow_upward
				</v-icon>
				<v-icon @click="moveFieldDown(index)" flat
					v-if="fieldCanBeMovedDown(index)">
					arrow_downward
				</v-icon>
				<v-icon @click="removeField(index)" flat>
					close
				</v-icon>
			</li>
		</ol>
	</div>
</template>

<script>

	export default {
		name: "ExportFieldList",

		props: {
			value: {
				type: Array
			},
		},

		watch: {
			form: {
				handler () {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data () {
			return {
				fields: this.value,
			};
		},

		methods: {

			updateFieldList () {
				this.$forceUpdate();
			},

			fieldCanBeMovedUp (index) {
				return index !== 0;
			},


			fieldCanBeMovedDown (index) {
				return this.fields.length > 0 && index !== this.fields.length - 1;
			},

			moveFieldUp (index) {
				this.swapTwoArrayElements(this.fields, index - 1, index);
			},

			moveFieldDown (index) {
				this.swapTwoArrayElements(this.fields, index + 1, index);
			},

			removeField (index) {
				this.fields.splice(index, 1);
			},

			swapTwoArrayElements (array, index1, index2) {
				array = [array[index1], array[index2]] = [array[index2], array[index1]];
				this.$forceUpdate();
			},
		},
	};
</script>
